import React, { useState, useRef, useEffect  } from 'react'; 
import { useTranslation } from 'react-i18next';   
import { config } from '../../../../utils/config';
import { callApi, showSweetAlert} from '../../../../utils/utils';   
import PageContent from 'layouts/PageContent';   
import { Row,Col,Card, CardHeader, CardTitle, CardBody, CardFooter} from 'reactstrap';  
import FieldDataTable from 'components/Controls/FieldDataTable/FieldDataTable.jsx';
import FieldDropdown from 'components/Controls/FieldDropdown.jsx' 
import FieldButton from 'components/Controls/FieldButton/FieldButton.jsx';
import FieldRadioButton from 'components/Controls/FieldRadioButton/FieldRadioButton.jsx';
import FieldTextArea  from 'components/Controls/FieldTextArea.jsx'
import FieldCalendar from 'components/Controls/FieldCalendar.jsx'
import '../ProductionDailyFollowUPScreen.scss';  
import * as yup from 'yup';
import YupValidator from '../../../../utils/YupValidator';
import { Column } from 'primereact/column';
import ProductionWeeklyFollowUPDepartamento from "../ProductionWeeklyFollowUPDepartamento";
import ProductionMonthlyFollowUPComentarios from "./ProductionMonthlyFollowUPComentarios";
import Highcharts from 'highcharts';
import FieldSelectButton from 'components/Controls/FieldSelectButton';
import { Skeleton } from 'primereact/skeleton';
import { Dialog } from 'primereact/dialog';
import DailyOperationProductionTrend from '../DailyOperationTracker/DailyOperationProductionTrend';
import moment from 'moment';
import { PrimeIcons } from 'primereact/api'; 

const ProductionMonthlyFollowUPScreen = (props) => { 
  const { t } = useTranslation(['wtw', 'common']);
  const [errors, setErrors] = useState({});   
  const [AnioMesLista, setAnioMesLista] = useState([]);
  const [SemanaLista, setSemanaLista] = useState([]);
  const [PlantasList, setPlantasList] = useState([]);
  const [DepartamentosList, setDepartamentosList] = useState([]);
  const [ComentariosList, setComentariosList] = useState([]);
  const [ClaAnioMes, setClaAnioMes] = useState(null);
  const [NomAnioMes, setNomAnioMes] = useState(null); 
  const [IdProduccionSeguimientoSemanal, setIdProduccionSeguimientoSemanal] = useState(null); 
  const [IdProduccionSeguimientoSemanalDepartamento, setIdProduccionSeguimientoSemanalDepartamento] = useState(null);
  const [ClaUbicacion, setClaUbicacion] = useState(null);
  const [NomUbicacion, setNomUbicacion] = useState(null);
  const [ClaDepartamento, setClaDepartamento] = useState(null);
  const [NomDepartamento, setNomDepartamento] = useState(null);
  const [ClaArea, setClaArea] = useState(null);
  const [NomArea, setNomArea] = useState(null);
  const [ClaSemana, setClaSemana] = useState(null); 
  const [NomSemana, setNomSemana] = useState(null); 
  const [ExplicacionProblema, setExplicacionProblema] = useState(null); 
  const [ExplicacionProblemaDepartamento, setExplicacionProblemaDepartamento] = useState(null); 
  const [IsOnSearchApplied, setIsOnSearchApplied] = useState(false); 
  const [PosibleSolucionProblema, setPosibleSolucionProblema] = useState(null); 
  const [FechaVencimiento, setFechaVencimiento] = useState(null); 
  const [EsMostrarDialogDepartament, setEsMostrarDialogDepartament] = useState(false); 
  const [EsMostrarDialogComentarios, setEsMostrarDialogComentarios] = useState(false); 
  const [EsActionPlan, setEsActionPlan] = useState(null);  
  const [TurnoList, setTurnoList] = useState([]);
  const [ClaTurno, setClaTurno] = useState([1, 2, 3]);
  const [EsCargandoListado, setEsCargandoListado] = useState(false);
  const [EsMostrarProduccionTendencia, setEsMostrarProduccionTendencia] = useState(false);
  const [ComentariosPlantaList, setComentariosPlantaList] = useState([]);
  const [FechaFin, setFechaFin] = useState(null);  

  useEffect(() => {
    getAnioMes();
    getPlantas();
    GetTurno();
  }, [])

const getAnioMes = () => {  
  const urlWebService = `${config.UrlApiProject}WTW/GetAnioMesProduccionSeguimientoCmb`; 
  const paramsService= {};  
  callApi(urlWebService, 'GET', paramsService, (response) => {
    setAnioMesLista(response.data.AnioMesLista);
  }, null, false, true);
}

const getPlantas = () => {  
  const urlWebService = `${config.UrlApiProject}WTW/GetPlantasProduccionSeguimientoCmb`; 
  const paramsService= {};  
  callApi(urlWebService, 'GET', paramsService, (response) => {
    setPlantasList(response.data.PlantasList);
  }, null, false, true);
}

const getSemanas = (anioMes) => {  
  const urlWebService = `${config.UrlApiProject}WTW/GetSemanaProduccionSeguimientoCmb?AnioMes=${anioMes}`; 
  const paramsService= {};  
  callApi(urlWebService, 'GET', paramsService, (response) => {
    setSemanaLista(response.data.SemanaLista);
  }, null, false, true);
}

const GetTurno = () => {
  const paramsService = {};
  const urlWebService = `${config.UrlApiProject}Operations/GetTurno`;
  callApi(urlWebService, 'GET', paramsService, (response) => {
    setTurnoList(response.data.Turnos);
  });
};

const onChangeClaUbicacion = (e) => {  
    const newErrors = { ...errors } 
    delete newErrors.ClaUbicacion;
    setErrors(newErrors)  
    setClaUbicacion(e.value);
    setIsOnSearchApplied(false);
    const UbicacionList = [...PlantasList];
    const UbicacionName = UbicacionList.filter((item) => item.ClaUbicacion === e.value)[0];
    if(UbicacionName!==undefined){
      setNomUbicacion(UbicacionName.NombreUbicacion);  
    }  
};

const onChangeClaAnioMes = (e) => {  
  const newErrors = { ...errors } 
  delete newErrors.ClaAnioMes;   
  setErrors(newErrors)  
  setClaAnioMes(e.value);
  setIsOnSearchApplied(false);
  const AnioMesList = [...AnioMesLista];
  const AniMesName = AnioMesList.filter((item) => item.ClaAnioMes === e.value)[0];
  if(AniMesName!==undefined){
    setNomAnioMes(AniMesName.NomAnioMes);  
  }
  getSemanas(e.value);  
};
 

const valitationSchemeApply = yup.object().shape({
  ClaUbicacion: yup.mixed().required(t('common:RequiredField')).nullable(),
  ClaAnioMes: yup.mixed().required(t('common:RequiredField')).nullable() 
}); 
 

function agruparComentariosPorSemanaYPlanta(data) { 
  const resultado = data.reduce((grupo, item) => { 
      if (item.ClaArea < 0) { 
          let semana = grupo.find(g => g.claSemana === item.ClaSemana); 
          if (!semana) {
              semana = {
                  claSemana: item.ClaSemana,
                  nomSemana: item.NomSemana,
                  departamentos: []
              };
              grupo.push(semana);
          } 
          let departamento = semana.departamentos.find(d => d.ClaArea === item.ClaArea); 
          if (!departamento) {
              departamento = {
                  claArea: item.ClaArea,
                  nomArea: item.NomArea,
                  nomDepartamento: item.NomDepartamento,
                  comentarios: []
              };
              semana.departamentos.push(departamento);
          } 
          departamento.comentarios.push(item);
      }

      return grupo;
  }, []);

  return resultado;
}

const onSearch = async () => {  
        setExplicacionProblema(null);
        setPosibleSolucionProblema(null);
        setPosibleSolucionProblema(null);
        setFechaVencimiento(null);
        setEsActionPlan(false);
        setDepartamentosList([]);
        setComentariosPlantaList([]);
        setComentariosList([]);
        const value = {
          ClaUbicacion,
          ClaAnioMes 
        } 
        const validator = new YupValidator(valitationSchemeApply);
        const esValido = await validator.validate(value);
        
        if (!esValido){ 
          showSweetAlert(t('common:Warning'), t('common:ReviewRequiredFields'), 'warning'); 
          setErrors(validator.errors); 
          return;
        }
      const urlWebService = `${config.UrlApiProject}WTW/GetProduccionSeguimientoMensualDepartamento`; 
      const paramsService = {
        ClaUbicacion,
        ClaAnioMes,
        ClaTurnos: '' 
      }; 
      callApi(urlWebService, 'POST', paramsService, (response) => {
        const data = response.data.ProduccionSeguimientoPlanta[0];
        setIdProduccionSeguimientoSemanal(null);
        if(data!==undefined){
          setIdProduccionSeguimientoSemanal(data.IdProduccionSeguimientoSemanal);
          setExplicacionProblema(data.ExplicacionProblema);
          setPosibleSolucionProblema(data.PosibleSolucionProblema);
          let fechaVencimiento = null;
          if(data.FechaVencimiento!==null){
            fechaVencimiento = new Date(data.FechaVencimiento)
          }
          setFechaVencimiento(fechaVencimiento);
          setEsActionPlan(data.EsActionPlan);
        }
        setDepartamentosList(response.data.DepartamentosList);
        setComentariosList(response.data.ProduccionSeguimientoPlanta);  
        const comentariosPlanta = agruparComentariosPorSemanaYPlanta(response.data.ProduccionSeguimientoPlanta);
        setComentariosPlantaList(comentariosPlanta);
        console.log('onSearch comentariosPlanta',comentariosPlanta)
        setIsOnSearchApplied(true);
      }, () => {
    });
};

 
 
const filters = (
  <>
    <Row className="pt-3 pb-3">
      <Col>
        <div className="p-fluid">
          <FieldDropdown  
            name="ClaUbicacion"
            value={ClaUbicacion} 
            options={PlantasList}  
            optionValue="ClaUbicacion"
            optionLabel="NombreUbicacion" 
            onChange={(e) => onChangeClaUbicacion(e)}
            label={t('wtw:Plant')}
            errors={errors}
          />   
        </div>
      </Col>
      <Col>
        <div className="p-fluid">
          <FieldDropdown  
            name="ClaAnioMes"
            value={ClaAnioMes} 
            options={AnioMesLista}  
            optionValue="ClaAnioMes"
            optionLabel="NomAnioMes" 
            onChange={(e) => onChangeClaAnioMes(e)}
            label={t('wtw:YearMonth')}
            errors={errors}
          />     
        </div>
      </Col> 
      <Col lg={2} md={2} sm={2} xs={2}>
        <div className='text-right'>
          <FieldButton
            label={t('common:Search')}
            icon="pi pi-search"
            className="p-button p-highlight"
            onClick={() => onSearch()}
          >
          </FieldButton>
        </div> 
      </Col>
    </Row>  
  </>
);

const AreaDepartamentoColumna = (row) => {  
    
    if (row.ClaArea === -1){
      return (
        <> 
          <div className='overflow-ellipsis' title={row.NomArea}> 
            {row.NomArea} 
          </div> 
        </>
  );
    }
    if (row.IdProduccionSeguimientoSemanal>0){
      return (
        <> 
          <div className='overflow-ellipsis link-text primary-color' title={row.NomArea} onClick={() =>onViewComments(row)}>
            {row.NomArea}
          </div>
        </>
      );
    }
    return (
      <>
        <div>
          <span className='overflow-ellipsis primary-color' title={row.NomArea}> 
            {row.NomArea}
          </span>
        </div>
      </>
);
}

const ComentariosTemplate = (row) => {
  if (row.ClaArea === -1){
    return (
      <>   
      </>
   );
  }
  
  if (row.IdProduccionSeguimientoSemanal>0){
    return (
      <> 
        <i   
          className="fas fa-comments light-yellow-color cursor"
          onClick={()=>  onViewComments(row)}
        > 
        </i>
      </>
    );
  }

  return (
    <> 
      <i   
        className="fas fa-comments light-gray-color"
        style={{cursor:"not-allowed"}}
        title={t('wtw:NoCommentsAvailable')}
      > 
      </i>
    </>
  );
} 



const onViewComments = async (item) => {  
    if (item === undefined) {
      const departamentos = ComentariosPlantaList[0];
      if(departamentos!==undefined){
        if (departamentos.departamentos !== undefined) {
          const info = departamentos.departamentos[0].comentarios[0];
          item = info;
        }
      }
    }
    if(item!==undefined){
      setClaDepartamento(item.ClaDepartamento);
      setNomDepartamento(item.NomDepartamento);
      setExplicacionProblemaDepartamento(item.Comentarios);
      setIdProduccionSeguimientoSemanalDepartamento(item.IdProduccionSeguimientoSemanal);
      setClaArea(item.ClaArea);
      setNomArea(item.NomArea);
      setEsMostrarDialogComentarios(true);
    }
};


const CajasTemplateCol = (item, columnName, decimals, columnNamePrev, columnNamePorc) => {
  const currentValue = item[columnName];
  const prevValue = item[columnNamePrev];
  const prevValuePoc = columnNamePorc ? item[columnNamePorc] : null;
  let changeIcon = '';
  let percentageChange = 0;

  if (prevValuePoc !== null && prevValuePoc !== 0) {
    percentageChange = prevValuePoc; 
    changeIcon = percentageChange > 0 ? PrimeIcons.ARROW_UP : PrimeIcons.ARROW_DOWN;
  }
  console.log('columnNamePrev',columnNamePrev,'prevValue',prevValue)
  return (
    <> 
      {columnNamePrev && prevValue !== null && prevValue !== 0 && prevValue !== undefined ? (
        <span style={{ whiteSpace: 'nowrap' }}>
          {Highcharts.numberFormat(item[columnName], decimals, '.', ',')} 
          <small
            title={`${t('wtw:titleWeekPrev')} ${Highcharts.numberFormat(Math.abs(prevValue), decimals, '.', ',')}`} 
            style={{ marginLeft: '8px', alignItems: 'center', color: percentageChange > 0 ? 'green' : 'red' }}
          >
            ({Highcharts.numberFormat(Math.abs(percentageChange), decimals, '.', ',')}%)
            <i className={changeIcon} style={{ marginLeft: '4px', fontSize: '0.875em' }}></i>
          </small>
        </span>
      ) : (
        <span style={{ whiteSpace: 'nowrap' }}>
          {Highcharts.numberFormat(item[columnName], decimals, '.', ',')}
        </span>
      )}
    </>
    );
};  

const DecimalTemplateCol = (item, columnName, decimals, columnNamePrev, columnNamePorc) => {
  const currentValue = item[columnName];
  const prevValue = item[columnNamePrev];
  const prevValuePorc = columnNamePorc ? item[columnNamePorc] : null;
  let changeIcon = '';
  let percentageChange = null;

  if (prevValuePorc !== null && prevValuePorc !== 0) {
    percentageChange = prevValuePorc; 
    changeIcon = percentageChange > 0 ? PrimeIcons.ARROW_UP : PrimeIcons.ARROW_DOWN;
  }

  return (
    <>
      {columnNamePrev && prevValue !== null && prevValue !== 0 && prevValue !== undefined ? (
        <span style={{ whiteSpace: 'nowrap' }}>
          {Highcharts.numberFormat(item[columnName], decimals, '.', ',')}
          <small
            title={`${t('wtw:titleWeekPrev')} ${Highcharts.numberFormat(Math.abs(prevValue), decimals, '.', ',')}`}
            style={{ marginLeft: '8px', alignItems: 'center', color: percentageChange > 0 ? 'green' : 'red' }}
          >
            ({Highcharts.numberFormat(Math.abs(percentageChange), decimals, '.', ',')}%)
            <i className={changeIcon} style={{ marginLeft: '4px', fontSize: '0.875em' }}></i>
          </small>
        </span>
    ) : (
      <span style={{ whiteSpace: 'nowrap' }}>
        {Highcharts.numberFormat(item[columnName], decimals, '.', ',')}
      </span>
    )}
    </>
  
  );
};

const PorcentajeTemplateCol = (item, columnName, columnNamePrev, columnNamePorc) => {
  const currentValue = item[columnName];
  const prevValue = item[columnNamePrev];
  const prevValuePorc = columnNamePorc ? item[columnNamePorc] : null;
  let changeIcon = '';
  let percentageChange = null; 

  if (prevValuePorc !== null && prevValuePorc !== 0) {
    percentageChange = prevValuePorc;
    changeIcon = percentageChange > 0 ? PrimeIcons.ARROW_UP : PrimeIcons.ARROW_DOWN;
  }

  return (
    <>
      {columnNamePrev && prevValue !== null && prevValue !== 0 && prevValue !== undefined ? (
        <span style={{ whiteSpace: 'nowrap' }}>
          {Highcharts.numberFormat(item[columnName], 2, '.', ',')}%
          <small
            title={`${t('wtw:titleWeekPrev')} ${Highcharts.numberFormat(Math.abs(prevValue), 1, '.', ',')}`}
            style={{ marginLeft: '8px', alignItems: 'center', color: percentageChange > 0 ? 'green' : 'red' }}
          >
            ({Highcharts.numberFormat(Math.abs(percentageChange), 1, '.', ',')}%)
            <i className={changeIcon} style={{ marginLeft: '4px', fontSize: '0.875em' }}></i>
          </small>
        </span>
    ) : (
      <span style={{ whiteSpace: 'nowrap' }}>
        {Highcharts.numberFormat(item[columnName], 2, '.', ',')}%
      </span>
    )}
    </>
  
  );
};

const PorcentajeScrapTemplateCol = (item, columnName, columnNamePrev, columnNamePorc) => {
  const currentValue = item[columnName];
  const prevValue = item[columnNamePrev];
  const prevPorc = columnNamePorc ? item[columnNamePorc] : null;
  let changeIcon = '';
  let percentageChange = null; 

  if (prevPorc !== null && prevPorc !== 0) {
    percentageChange = prevPorc;
    changeIcon = percentageChange > 0 ? PrimeIcons.ARROW_UP : PrimeIcons.ARROW_DOWN;
  }

  return (
    <>
      {columnNamePrev && prevValue !== null && prevValue !== 0 && prevValue !== undefined ? (
        <span style={{ whiteSpace: 'nowrap' }}>
          {Highcharts.numberFormat(item[columnName], 2, '.', ',')}%
          <small
            title={`${t('wtw:titleWeekPrev')} ${Highcharts.numberFormat(Math.abs(prevValue), 2, '.', ',')}`}
            style={{ marginLeft: '8px', alignItems: 'center', color: percentageChange < 0 ? 'green' : 'red' }}
          >
            ({Highcharts.numberFormat(Math.abs(percentageChange), 2, '.', ',')}%)
            <i className={changeIcon} style={{ marginLeft: '4px', fontSize: '0.875em' }}></i>
          </small>
        </span>
    ) : (
      <span style={{ whiteSpace: 'nowrap' }}>
        {Highcharts.numberFormat(item[columnName], 2, '.', ',')}%
      </span>
    )}
    </>
  
  );
};  
 

  const rowClass = (data) => {
    return {
        'light-gray': data.ClaArea === -1
    }
  }

 
  const skeletonTemplate = () =>{
    return (<Skeleton height="1rem" width="100%" className="mb-2"></Skeleton>);
  }  

  const showProductionTrend = (item) => {  
    let fechaFinal = null;
    const data = ComentariosPlantaList[0];
    if(data!==undefined){
      if (data.departamentos !== undefined) {
        const info = data.departamentos[0].comentarios[0];
        fechaFinal = info.FechaFin;
      }
    }
    setNomArea(item.NomArea);
    setClaArea(item.ClaArea);
    setFechaFin(fechaFinal);
    setEsMostrarProduccionTendencia(true);
  }

  const headerDialogProductionTrendDetail = () => {
    return (
      <>
        {t('wtw:ProductionTrendDetail')} - {moment(FechaFin).format('MMMM, YYYY') } - {NomArea} - {t('wtw:Shift')} : {t('wtw:All')} - {t('wtw:Cell')}: {t('wtw:All')}
      </>
    )
  } 

  const ListadoDepartamentos = () => {
    if (EsCargandoListado){
      return (
        <> 
          <FieldDataTable 
            value={[{},{},{},{}]}
            paginator={false} 
          >     
            <Column
              body={skeletonTemplate}
              header={t('formulario:Departament')} 
              columnKey="MTons"
              headerStyle={{ width: '100px' }}
            >
            </Column>    
            <Column header={t('wtw:Boxes')} className='text-right' headerStyle={{ width: '100px' }} body={skeletonTemplate}></Column>
            <Column header={t('wtw:UnitsByHr')} className='text-right' headerStyle={{ width: '80px' }} body={skeletonTemplate}></Column>
            <Column header={t('wtw:Tons')} className='text-right' headerStyle={{ width: '100px' }} body={skeletonTemplate}></Column>
            <Column header={t('wtw:Scrap')} className='text-right' headerStyle={{ width: '100px' }} body={skeletonTemplate}></Column>
            <Column header={t('wtw:Utilizacion')} className='text-right' headerStyle={{ width: '80px' }} body={skeletonTemplate}></Column> 
            <Column header={t('wtw:Disponibilidad')} className='text-right' headerStyle={{ width: '80px' }} body={skeletonTemplate}></Column>
            <Column header={t('wtw:Efficiencia')} className='text-right' headerStyle={{ width: '80px' }} body={skeletonTemplate}></Column>
            <Column header={t('wtw:OEE')} className='text-right' headerStyle={{ width: '80px' }} body={skeletonTemplate}></Column>
          </FieldDataTable>
        </>  
      )
    }
    return (
      <FieldDataTable 
        value={DepartamentosList}    
        paginator={false}
        rowClassName={rowClass}
        className="p-datatable-striped"
      > 
        <Column
          body={ComentariosTemplate}
          header='' 
          headerStyle={{ width: '20px' }}
        >
        </Column>  
        <Column
          body={AreaDepartamentoColumna}
          header={t('formulario:Departament')} 
          columnKey="MTons"
          headerStyle={{ width: '90px' }}
        >
        </Column>   
        <Column header={t('wtw:Boxes')} className='text-right' headerStyle={{ width: '120px' }} body={(rowData)=> CajasTemplateCol(rowData, 'Cajas', 0, 'CajasPrev', 'CajasPorc')}></Column>
        <Column header={t('wtw:UnitsByHr')} className='text-right' headerStyle={{ width: '120px' }} body={(rowData)=> DecimalTemplateCol(rowData, 'UnitsByHr', 2, 'UnitsByHrPrev', 'UnitsByHrPorc')}></Column>
        <Column header={t('wtw:Tons')} className='text-right' headerStyle={{ width: '120px' }} body={(rowData)=> DecimalTemplateCol(rowData, 'Tons', 2, 'TonsPrev', 'TonsPorc')}></Column>
        <Column header={t('wtw:Scrap')} className='text-right' headerStyle={{ width: '120px' }} body={(rowData)=> PorcentajeScrapTemplateCol(rowData, 'Scrap', 'ScrapPrev', 'ScrapPorc')}></Column>
        <Column header={t('wtw:Utilizacion')} className='text-right' headerStyle={{ width: '120px' }} body={(rowData)=> PorcentajeTemplateCol(rowData, 'Utilizacion', 'UtilizacionPrev', 'UtilizacionPorc')}></Column> 
        <Column header={t('wtw:Disponibilidad')} className='text-right' headerStyle={{ width: '120px' }} body={(rowData)=> PorcentajeTemplateCol(rowData, 'Disponibilidad', 'DisponibilidadPrev', 'DisponibilidadPorc')}></Column>
        <Column header={t('wtw:Efficiencia')} className='text-right' headerStyle={{ width: '120px' }} body={(rowData)=> PorcentajeTemplateCol(rowData, 'Efficiencia', 'EfficienciaPrev', 'EfficienciaPorc')}></Column>
        <Column header={t('wtw:OEE')} className='text-right' headerStyle={{ width: '120px' }} body={(rowData)=> PorcentajeTemplateCol(rowData, 'OEE', 'OEEPrev', 'OEEPorc')}></Column>
      </FieldDataTable>
    )
  }

 

  return (
    <>   
      <PageContent title={t('wtw:ProductionMonthlyFollowUPTitle')} className="ProductionDailyFollowUPScreen">  
        <Row className='align-items-start pb-3'>
          <Col lg={12} md={12} sm={12} xs={12}>  
            {filters}
          </Col> 
        </Row> 
        {IsOnSearchApplied}
        {
          IsOnSearchApplied ?
          (
            <>
               
              <Row className='align-items-start'>
                <Col lg={12} md={12} sm={12} xs={12}> 
                  <Row className='pb-2'>
                    <Col> <span className='h2'>{t('wtw:ResultsbyDepartment')}</span> </Col>
                    <Col className='pb-2 text-right'>
                      <div className='' onClick={() => showProductionTrend({ClaArea: null, NomArea:  t('wtw:AllDepatments') })}><span className='bold link-text primary-color'>View Production Trend <i className="fas fa-external-link-alt"></i></span></div> 
                    </Col> 
                  </Row> 
                  {ListadoDepartamentos()} 
                </Col>  
                <Col lg={12} md={12} sm={12} xs={12}>
                  <Row className='pb-3 pt-3'>
                    <Col>
                      <span className='h2'>{t('wtw:PlantlevelComments')}</span>
                      <div className='info-color'>
                        <small>{t('wtw:PlantlevelCommentsInstructions')}</small>
                        <br></br>
                        <small><i>Click <b className='cursor' onClick={()=>  onViewComments()}>here</b> to view comments organized by department.</i></small>
                      </div>
                    </Col>
                  </Row>


                  {ComentariosPlantaList.map((element, index) => (
                    <div key={index}>
                      <Row className='align-items-start pt-1'>
                        <Col>
                          <h3>{element.nomSemana}</h3>
                        </Col>
                      </Row>
                      <Row className='align-items-start pt-1'>
                        {element.departamentos && element.departamentos.length > 0 ? (
                          element.departamentos.map((departamento, depIndex) => (
                            <Col key={depIndex}>

                              <Card>
                                <CardBody className="" style={{paddingTop: "5px"}}> 
                                  <Row className="align-items-start">
                                    <Col>
                                        &nbsp;
                                    </Col>
                                  </Row>  
                                  <Row className="align-items-start">
                                    <Col>
                                      <div className="p-fluid">
                                        <span>{`${t('wtw:Comments')}:`}</span>
                                        <FieldTextArea 
                                          name="ExplicacionProblema"
                                          value={departamento.comentarios[0].ExplicacionProblema}  
                                          errors={errors} 
                                          readOnly={true}
                                          autoResize={true}
                                          maxLength={3000}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card> 
                            </Col>
                          ))
                        ) : (
                          <Col>
                            <div className='pt-2'>
                              <span className='label'>
                                {t('wtw:NoDepartments')}
                              </span>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  ))}
                </Col>
              </Row> 
            </>
          )
          :
          (
            <>
              <Card className='card-produccion' hidden={!IsOnSearchApplied}>
                <CardBody className="" style={{paddingTop: "5px"}}>
                  <Row className='pt-2'>
                    <Col lg={12} md={12} sm={12} xs={12}>  
                      {t('wtw:MessageNoData')}
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className='card-produccion' hidden={IsOnSearchApplied}>
                <CardBody className="" style={{paddingTop: "5px"}}>
                  <Row className='pt-2'>
                    <Col lg={12} md={12} sm={12} xs={12}>  
                      {t('wtw:DoNotForgetClickSearch')}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </>
          )
        }
         
        {
        EsMostrarDialogComentarios && 
        (
          <ProductionMonthlyFollowUPComentarios  
            Visible={EsMostrarDialogComentarios}
            ComentariosList={ComentariosList}
            onHide={()=> setEsMostrarDialogComentarios(false)}  
            ClaUbicacion={ClaUbicacion}
            ClaAnioMes={ClaAnioMes} 
            ClaSemana={ClaSemana}
            NomUbicacion={NomUbicacion}
            NomAnioMes={NomAnioMes}
            NomSemana={NomSemana}
            ClaTipo={1} 
            IsModal={true}
            FechaInicio={null}
            FechaFin={null}
            ClaDepartamento={ClaDepartamento}  
            ClaArea={ClaArea}
            NomArea={NomArea}   
            NomDepartamento={NomDepartamento}
            IdProduccionSeguimientoSemanal={IdProduccionSeguimientoSemanalDepartamento}
            Comentarios={ExplicacionProblemaDepartamento}
          >
          </ProductionMonthlyFollowUPComentarios>
        )
      } 

        {EsMostrarProduccionTendencia ? (
          <>
            <Dialog 
              visible={EsMostrarProduccionTendencia}
              header={headerDialogProductionTrendDetail} 
              draggable={false}
              modal 
              maximized={true}
              className="DailyOperationAssetDetailTree dialog-header-background-blue"
              onHide={() => setEsMostrarProduccionTendencia(false)}
              position="top"
              blockScroll={true}
            > 
              <DailyOperationProductionTrend
                visible={EsMostrarProduccionTendencia} 
                Fecha={FechaFin}
                ClaUbicacion={ClaUbicacion}
                ClaArea={ClaArea}
                ClaCelda={null}
                ClaTurno={null}
                DisableFilters={true}
              >
              </DailyOperationProductionTrend>
            </Dialog>  
          </>
        ) : (
          <></>
        )}  
      </PageContent> 
    </>
  );
};

export default ProductionMonthlyFollowUPScreen;
